<script setup lang="ts">
import { ref } from 'vue';
import i18n from '@/i18n';
import { NEW, BOOKED, FINAL_PAYMENT_DUE, EXPIRED } from '@/constants';
import { useMyQuoteStore } from '@/store/MyQuoteStore';
import { useUserInfo } from '@/modules/user/useUserInfo';

const myQuoteStore = useMyQuoteStore();
const userInfo = useUserInfo();
const statisticPaymentDue = ref();
const statisticBooked = ref();
const statisticExpire = ref();
const statisticNew = ref();

const emits = defineEmits<{ statusEvent: [value: string] }>();

const filterEmit = (status: string) => {
  emits('statusEvent', status);
};

const getData = async () => {
  const currentUser = await userInfo.getUserInfo();
  const userEmail = currentUser?.email;
  if (userEmail) {
    await myQuoteStore.getStatistic(userEmail);
    statisticPaymentDue.value = myQuoteStore?.statistic.FINAL_PAYMENT_DUE == null ? 0 : myQuoteStore.statistic.FINAL_PAYMENT_DUE;
    statisticBooked.value = myQuoteStore?.statistic.BOOKED == null ? 0 : myQuoteStore.statistic.BOOKED;
    statisticExpire.value = myQuoteStore?.statistic.EXPIRED == null ? 0 : myQuoteStore.statistic.EXPIRED;
    statisticNew.value = myQuoteStore?.statistic.NEW == null ? 0 : myQuoteStore.statistic.NEW;
  }
};
getData();
</script>

<template>
  <div class="surface-ground">
    <div class="grid">
      <div id="stats-new" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit(NEW)">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block mb-3 border-round uppercase"> {{ i18n.global.t('my_quote.received') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticNew }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticNew }} </span>
            <span> {{ ' ' + i18n.global.t('status.since_last_visit') }}</span>
          </div>
        </a>
      </div>
      <div id="stats-expired" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit(EXPIRED)">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block font-medium mb-3 uppercase">{{ i18n.global.t('status.expiring') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticExpire }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticExpire }} </span>
            <span> {{ ' ' + i18n.global.t('status.since_last_week') }}</span>
          </div>
        </a>
      </div>
      <div id="stats-booked" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit(BOOKED)">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block font-medium mb-3 uppercase">{{ i18n.global.t('my_quote.booked') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticBooked }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticBooked }}</span>
            <span> {{ ' ' + i18n.global.t('status.newly_booked') }}</span>
          </div>
        </a>
      </div>
      <div id="stats-payment-due" class="col-12 md:col-6 lg:col-3">
        <a class="no-underline" href="javascript:" @click="filterEmit(FINAL_PAYMENT_DUE)">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block font-medium mb-3 uppercase">{{ i18n.global.t('status.payment_due') }}</span>
                <div class="text-900 font-medium text-xl">{{ statisticPaymentDue }}</div>
              </div>
            </div>
            <span class="text-primary font-medium">{{ statisticPaymentDue }}</span>
            <span> {{ ' ' + i18n.global.t('status.bookings') }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
